module.exports = __webpack_public_path__ + "img/not-found-404.3cf1b63b.png";